import { Routes } from '@angular/router';
import { PatientType } from './patient-type/patient-type';
import { NewPatient } from './new-patient/default/new-patient';
import { AvailableSlotsWrapper } from './variants/available-slots/available-slots-wrapper';
import { DetailsMEWrapper } from './variants/details-me/details-me-wrapper';
import { AppointmentScheduled } from './appointment-scheduled/appointment-scheduled';
import { NotFound } from './not-found/not-found';
import { ReferralForm } from './referral/referral-form';
import { ReferralState } from './referral/referral-state';
import { ReferralSuccess } from './referral/referral-success';
import { InPersonSuccess } from './inperson-success/inperson-success';
import { NCPsychotherapyWaitlist } from './nc-psychotherapy-waitlist/nc-psychotherapy-waitlist';
import { waitlistGuard, waitlistSuccessGuard, changeLogsAvailableGuard, changeLogsAuthGuard } from './route-guards';
import { ChangeLogsLogin } from './change-logs-login/change-logs-login';
import { ChangeLogsAdmin } from './change-logs-admin/change-logs-admin';
import { isChangeLogsEnabled } from '../environments/environment';

const changeLogsRoutes: Routes = isChangeLogsEnabled()
  ? [
      { path: 'change-logs/login', component: ChangeLogsLogin, canActivate: [changeLogsAvailableGuard] },
      { path: 'change-logs', component: ChangeLogsAdmin, canActivate: [changeLogsAvailableGuard, changeLogsAuthGuard] },
    ]
  : [];

export const routes: Routes = [
  { path: '', redirectTo: '/scheduler', pathMatch: 'full' },
  { path: 'scheduler', component: PatientType },
  { path: 'newpatient', component: NewPatient },
  { path: 'available-slots', component: AvailableSlotsWrapper },
  { path: 'details-me', component: DetailsMEWrapper },
  { path: 'appointment-scheduled', component: AppointmentScheduled },
  { path: 'referral', component: ReferralForm },
  { path: 'referral/state', component: ReferralState },
  { path: 'referral/success', component: ReferralSuccess },
  { path: 'inperson/success', component: InPersonSuccess },
  { path: 'waiting-list', component: NCPsychotherapyWaitlist, canActivate: [waitlistGuard] },
  { path: 'waiting-list-confirmation', component: NCPsychotherapyWaitlist, canActivate: [waitlistSuccessGuard] },
  ...changeLogsRoutes,
  { path: '**', component: NotFound }
];
